import { isPayLaterProduct, isSecuredInstallmentLoanProduct, isSetpayLegacyProduct } from './productTypeHelpers';
export default function getLoanProductPaymentAmount(accountSummary) {
    const { product: { type: productType }, billing, installment } = accountSummary;
    if (isPayLaterProduct(productType)) {
        return billing.fixedPaymentAmount;
    }
    if (isSetpayLegacyProduct(productType)) {
        return installment.monthlyAmountDue;
    }
    if (isSecuredInstallmentLoanProduct(productType)) {
        return billing.fixedPaymentAmount;
    }
    throw new Error('Unsupported product type');
}
